var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.568,
    height: 41.569,
    viewBox: "0 0 41.568 41.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M1063,387.235a20.784,20.784,0,1,0,20.783,20.784A20.807,20.807,0,0,0,1063,387.235Zm0,38.9a18.118,18.118,0,1,1,18.119-18.119A18.139,18.139,0,0,1,1063,426.138Z",
    transform: "translate(-1042.212 -387.235)",
    fill: "#05B4EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M1080.6,410.232a.454.454,0,0,0-.309-.337,1.587,1.587,0,0,0-.835.059s-18.6,6.685-19.661,7.425c-.229.16-.305.252-.344.361-.183.527.389.759.389.759l4.793,1.562a.524.524,0,0,0,.243-.014c1.091-.689,10.971-6.929,11.541-7.138.09-.027.156,0,.139.066-.228.8-8.81,8.429-8.81,8.429a.426.426,0,0,0-.054.088l-.011-.007-.447,4.755s-.187,1.457,1.269,0c1.028-1.028,2.022-1.888,2.52-2.306,1.648,1.138,3.422,2.4,4.187,3.055a1.331,1.331,0,0,0,.971.374c.727-.027.929-.825.929-.825s3.389-13.64,3.5-15.468c.011-.179.026-.293.028-.417A1.55,1.55,0,0,0,1080.6,410.232Z",
    transform: "translate(-1049.873 -397.308)",
    fill: "#05B4EF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.918195599254f2f077e0c99e2c5abc86.svg";
export { ForwardRef as ReactComponent };